import { z } from 'zod';

import { codec } from '@/hooks/router/use-query-params';

import { ChartTypeSchema } from '../entities/chart-type';

export const DATA_EXPLORER_QUERY_PARAMS = {
  deviceId: {
    key: 'device',
    schema: z.string().optional(),
    codec: codec.string,
  },
  topId: {
    key: 'top',
    schema: z.string().optional(),
    codec: codec.string,
  },
  unitIds: {
    key: 'unit',
    schema: z.array(z.string()).optional(),
    codec: codec.array(codec.string, '-'),
  },
  chartTypes: {
    key: 'chart',
    schema: z.array(ChartTypeSchema).optional(),
    codec: codec.array(codec.string, '-'),
  },
  from: {
    key: 'from',
    schema: z.date().optional(),
    codec: codec.date,
  },
  to: {
    key: 'to',
    schema: z.date().optional(),
    codec: codec.date,
  },
  filterNoise: {
    key: 'filter_noise',
    schema: z.boolean().optional(),
    codec: codec.boolean,
  },
} as const;
